export const buttonStyle = {
  'minWidth': '80px',
  'marginLeft': '20px',

  '&:first-child': {
    marginLeft: 0,
  },
};

export const headerWrapperStyle = {
  padding: '16px 0 16px',
  display: 'flex',
};

export const saveAsTemplateIconStyle = {
  marginRight: `8px`,
}
